/**
 * Cross-platform sharing: CTA and UTM for driving traffic back to Petso.
 */

export const PETSO_CTA_TEXT =
  '🐾 Meet my pet on Petso – the Digital ID & care platform for pets\n👉 https://petso.io';

/** Base URL for CTA links (with optional UTM params for analytics) */
export const PETSO_CTA_URL = 'https://petso.io';

/**
 * Build CTA URL with UTM parameters for tracking traffic from external socials.
 * @param source - Platform name (instagram, facebook, tiktok, x)
 * @param medium - e.g. 'social'
 * @param campaign - e.g. 'cross_post'
 */
export function buildCtaUrl(
  source: string,
  medium = 'social',
  campaign = 'cross_post'
): string {
  const params = new URLSearchParams({
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  });
  return `${PETSO_CTA_URL}?${params.toString()}`;
}

/** Platform display names */
export const PLATFORM_LABELS: Record<string, string> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  x: 'X (Twitter)',
};

/** Max caption length per platform (chars) – used when formatting for cross-post */
export const PLATFORM_CAPTION_LIMITS: Record<string, number> = {
  instagram: 2200,
  facebook: 63206,
  tiktok: 150,
  x: 280,
};
